import { MapboxApi } from '@clients/mapbox'

const basePath = 'https://api.mapbox.com'

export function createMapboxAPIClient (): MapboxApi {
  return new MapboxApi({ basePath })
}
